<script>
import options from './DictionaryWord.options'
export default options
</script>

<template>
  <span
    @click="showDialog"
    @keydown.enter="showDialog"
    tabindex="0"
    class="kb-dictionary-word__highlighted"
    ref="highlighted"
    >{{ word }}</span
  >

  <template v-if="display">
    <div class="kb-dictionary-word" ref="wordPopup">
      <div class="kb-dictionary-word__triangle" ref="arrow"></div>

      <button
        class="kb-dictionary-word__close"
        aria-label="luk"
        ref="closeButton"
        @keydown="tapTrap"
        @click="closeDialog"
      >
        <div class="kb-ui-icon kb-ui-icon--ui-close"></div>
      </button>

      <template v-if="wordDefinition">
        <mark class="kb-dictionary-word__title">{{
          wordDefinition.title
        }}</mark>
        <mark class="kb-dictionary-word__definition">{{
          wordDefinition.definition
        }}</mark>
        <template v-if="wordArticleUrl">
          <mark class="kb-dictionary-word__article-link">
            <a
              class="kb-dictionary-word__article-link__button"
              :href="wordArticleUrl"
              >Læs hele beskrivelsen i ordbogen</a
            >
          </mark>
        </template>
      </template>
      <template v-else>
        <div>
          <div class="kb-dictionary-word__empty-title"></div>
          <div class="kb-dictionary-word__empty-text"></div>
          <div class="kb-dictionary-word__empty-text"></div>
        </div>
      </template>
    </div>
  </template>
</template>
